import { render, staticRenderFns } from "./SelectionChallengeEquipe.vue?vue&type=template&id=6397f1b4&scoped=true"
import script from "./SelectionChallengeEquipe.vue?vue&type=script&lang=js"
export * from "./SelectionChallengeEquipe.vue?vue&type=script&lang=js"
import style0 from "./SelectionChallengeEquipe.vue?vue&type=style&index=0&id=6397f1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397f1b4",
  null
  
)

export default component.exports